import './App.scss';
import React, { useMemo } from 'react';
import { Route, withRouter } from 'react-router-dom'
import { RegisterType, LoginType } from '@svort/component'
import { IntlProvider } from 'react-intl'
import { useCookies } from 'react-cookie';

import SwitchFade from './HOC/SwitchFade/SwitchFade'
import Header from './components/Header/Header'
import Main from './components/Main/Main'
import Feature from './components/Feature/Feature'
import AuthType from './components/AuthType/AuthType'
import Auth from './containers/Auth/Auth'
import Match from './containers/Match/Match'
import Liveness from './containers/Liveness/Liveness'
import Onboarding from './containers/Onboarding/Onboarding'

import EN from './lang/EN.json';
import RU from './lang/RU.json';
import InitAction from './containers/InitAction/InitAction';

function App() {

  const translation = useMemo(() => ({
    'en-us': EN,
    'ru': RU,
  }), []);

  const [cookies] = useCookies(['locale']);

  const locale = cookies.locale || 'en-us';

  return (
    <IntlProvider messages={translation[locale]} locale={locale}>
      <Header />
      <SwitchFade>
        <Route
          path='/debug'
          render={(props) => <Auth {...props}
            isDummy={true}
            isDebug={true}
            registerType={RegisterType.Dots}
            loginType={LoginType.Dots}
            locale={locale} />}
        />
        <Route
          path='/select-auth'
          render={(props) => <AuthType {...props} />}
        />
        <Route
          path='/select-onboarding'
          render={(props) => <AuthType {...props} isOnboarding={true} />}
        />
        <Route
          path='/auth-dots-maze'
          render={(props) => <Auth {...props}
            registerType={RegisterType.Dots}
            loginType={LoginType.Dots}
            locale={locale} />}
        />
        <Route
          path='/auth-scale-emotions'
          render={(props) => <Auth {...props}
            registerType={RegisterType.Scale}
            loginType={LoginType.Emotions}
            locale={locale} />}
        />
        <Route
          path='/auth-scale-distortion'
          render={(props) => <Auth {...props}
            registerType={RegisterType.Scale}
            loginType={LoginType.Distortion}
            locale={locale} />}
        />
        <Route
          path='/init-action'
          render={(props) => <InitAction {...props} />}
        />
        <Route
          path='/onboarding-dots-maze'
          render={(props) => <Onboarding {...props}
            registerType={RegisterType.Dots}
            loginType={LoginType.Dots}
            locale={locale} />}
        />
        <Route
          path={['/onboarding-scale-emotions', '/onboarding2']}
          render={(props) => <Onboarding {...props}
            registerType={RegisterType.Scale}
            loginType={LoginType.Emotions}
            locale={locale} />}
        />
        <Route
          path='/feature/matching'
          render={(props) => <Match {...props} />}
        />
        <Route
          path='/feature/liveness'
          render={(props) => <Liveness {...props} />}
        />
        <Route
          path='/feature/register1'
          render={(props) => <Auth {...props}
            isDummy={true}
            isSignIn={false}
            login={'dummy'}
            registerType={RegisterType.Sectors}
            locale={locale} />}
        />
        <Route
          path='/feature/register2'
          render={(props) => <Auth {...props}
            isDummy={true}
            isSignIn={false}
            login={'dummy'}
            registerType={RegisterType.Dots}
            locale={locale} />}
        />
        <Route
          path='/feature/register3'
          render={(props) => <Auth {...props}
            isDummy={true}
            isSignIn={false}
            login={'dummy'}
            registerType={RegisterType.Scale}
            locale={locale} />}
        />
        <Route
          path='/feature/login1'
          render={(props) => <Auth {...props}
            isDummy={true}
            isSignIn={true}
            login={'dummy'}
            loginType={LoginType.Maze}
            locale={locale} />}
        />
        <Route
          path='/feature/login2'
          render={(props) => <Auth {...props}
            isDummy={true}
            isSignIn={true}
            login={'dummy'}
            loginType={LoginType.Dots}
            locale={locale} />}
        />
        <Route
          path='/feature/login3'
          render={(props) => <Auth {...props}
            isDummy={true}
            isSignIn={true}
            login={'dummy'}
            loginType={LoginType.Emotions}
            locale={locale} />}
        />
        <Route
          path='/feature/login4'
          render={(props) => <Auth {...props}
            isLoginless={true}
            isSignIn={true}
            locale={locale} />}
        />
        <Route
          path='/feature/login5'
          render={(props) => <Auth {...props}
            isLiveness={true}
            isSignIn={true}
            loginType={LoginType.Emotions}
            locale={locale} />}
        />
        <Route
          path='/feature/login6'
          render={(props) => <Auth {...props}
            isLiveness={true}
            isSignIn={true}
            loginType={LoginType.Distortion}
            locale={locale} />}
        />
        <Route
          path='/feature/document'
          render={(props) => <Onboarding {...props}
            isDummy={true}
            locale={locale} />}
        />
        <Route
          path='/feature'
          render={(props) => <Feature {...props} />}
        />
        <Route
          path='/'
          render={(props) => <Main {...props} />}
        />
      </SwitchFade>
    </IntlProvider>
  );
}

export default withRouter(App);
